const yesNoToBool = (string) => {
  if (string === 'yes') {
    return true;
  } else if (string === 'no') {
    return false;
  }
};

export default yesNoToBool;
